import React from 'react'
import gql from 'graphql-tag'
import { Mutation } from 'react-apollo'
import { VideosTable_video } from 'routes/videos/components/VideosTable.fragments'

export const CREATE_VIDEO_FROM_UUID = gql`
  mutation CreateVideoFromUuidMutation($input: CreateVideoFromUuidInput!) {
    createVideoFromUuid(input: $input) {
      video {
        id
        ...VideosTable_video
      }
    }
  }

  ${VideosTable_video}
`

const CreateVideoFromUuid = ({ uuid, children, onCompleted }) => {
  return (
    <Mutation mutation={CREATE_VIDEO_FROM_UUID} onCompleted={onCompleted}>
      {mutate =>
        children(() =>
          mutate({
            variables: { input: { uuid: uuid } }
          })
        )
      }
    </Mutation>
  )
}

export default CreateVideoFromUuid



// WEBPACK FOOTER //
// ./src/mutations/CreateVideoFromUuid.js